import React, {useContext} from "react";

export default ({onClick}) => {

  return <div className="v-stack gap-4 sm:gap-6" slot="footer">
        <a className="button button--xl" onClick={onClick}>
          Continue
        </a>
    </div>;
}
